export const environment = {
	production: false,
	devtoolsProtection: false,
	identity2: 'https://api.tecalis.com/dev/identity/flow-int/api',
	/** Base WHIP de SRS (sin query). Ej: https://host:1990/rtc/v1/whip/ */
	srsWhipUrl: 'https://test.ossrs.identity.tecalis.dev:1990/rtc/v1/whip/',
	/** App SRS (carpeta de publicación / DVR) */
	srsApp: 'live',
	/**
	 * Token SRS (?token=) validado por srs-auth-hook.
	 * Debe coincidir con SRS_AUTH_TOKEN del servidor.
	 */
	srsWhipToken: 'YHc_X7GomsWUypPdeIGt8kibNPM0zXNClGS_-TmI2y8',
	saveScreenShot: true,
	videoQuality: 'HIGH' as 'ULTRA' | 'HIGH' | 'MEDIUM' | 'LOW' | 'CUSTOM',
	polFrameRecoveryEnabled: true,
	polPreviewUnusableTechnicalKoEnabled: true,
	/** NIF-960: journey EUDI solo INT/local hasta go-live PRE/PRO. */
	eudiWalletAllowed: true,
};
